import { render, staticRenderFns } from "./ShindanView.vue?vue&type=template&id=57f41fd8&scoped=true&"
import script from "./ShindanView.vue?vue&type=script&lang=js&"
export * from "./ShindanView.vue?vue&type=script&lang=js&"
import style0 from "./ShindanView.vue?vue&type=style&index=0&id=57f41fd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f41fd8",
  null
  
)

export default component.exports